import { ChevronRight, AlertTriangle, History, ListOrdered } from "lucide-react";
import "./bookingHome.css";

export const BI_CARDS = [
  { tab: "bookings", title: "Table Booking", sub: "(Bookings)", icon: "table", fill: "linear-gradient(160deg,#a3242c,#6d0f17 60%,#4a080e)" },
  { tab: "pickup", title: "Pickup Order Booking", icon: "pickup", fill: "linear-gradient(160deg,#1c8a4b,#0b5a2e 60%,#063a1d)" },
  { tab: "catering", title: "Catering Booking", icon: "catering", fill: "linear-gradient(160deg,#2a63c4,#123b8a 60%,#0a2360)" },
  { tab: "event", title: "Celebration at PB Booking", icon: "celebration", fill: "linear-gradient(160deg,#9b2a86,#62115a 60%,#3d0a39)" },
  { tab: "tiffin", title: "Tiffin Booking", icon: "tiffin", fill: "linear-gradient(160deg,#16909b,#0c5e69 60%,#063c44)" },
  { tab: "ganesh-modak", title: "Ganesh Modak", icon: "modak", fill: "linear-gradient(160deg,#c98a2c,#8a4f10 60%,#5a2f06)" },
  { tab: "corporate-invoices", title: "Corporate Invoice", icon: "invoice", fill: "linear-gradient(160deg,#6d3bb8,#43208a 60%,#2a0f5c)" },
  { tab: "gift-vouchers", title: "Gift Vouchers", icon: "gift", fill: "linear-gradient(160deg,#b0202f,#78101d 60%,#4f0812)" },
  { tab: "tables", title: "Tables", icon: "tables", light: true },
  { tab: "dashboard", title: "Dashboard", icon: "dashboard", light: true },
  { tab: "reminders", title: "Reminders", icon: "bell", light: true },
];
const GOLD_FILL = "linear-gradient(160deg,#fff4d1,#f1d38c 45%,#dcb25e 80%,#f6e1a4)";
export const SECONDARY = [
  { tab: "live-queue", label: "Live Queue", Icon: ListOrdered, testid: "tab-live-queue" },
  { tab: "overlap", label: "Overlaps", Icon: AlertTriangle, testid: "tab-overlap" },
  { tab: "history", label: "History", Icon: History, testid: "tab-history" },
];

const Motif = () => (
  <svg className="bi-motif" viewBox="0 0 120 12" fill="none" aria-hidden="true">
    <path d="M0 6h44M76 6h44" stroke="currentColor" strokeWidth="1.2" />
    <path d="M60 1l5 5-5 5-5-5z M50 6a3 3 0 1 0 0 .01 M70 6a3 3 0 1 0 0 .01" stroke="currentColor" strokeWidth="1.2" />
  </svg>
);

function BiCard({ c, i, onOpen }) {
  return (
    <button type="button" className={`bi-card ${c.light ? "bi-light" : ""}`} style={{ "--bi-fill": c.light ? GOLD_FILL : c.fill, animationDelay: `${i * 45}ms` }}
      onClick={() => onOpen(c.tab)} data-testid={`bi-card-${c.tab}`}>
      <img src={`/bi-icons/${c.icon}.png`} alt="" className="bi-icon" loading="lazy" />
      <span className="bi-card-title pr-8">{c.title}</span>
      {c.sub && <span className="bi-card-sub">{c.sub}</span>}
      <Motif />
      <span className="bi-arrow"><ChevronRight className="h-5 w-5" /></span>
    </button>
  );
}

export function SecondaryNav({ active, onOpen }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="bi-secondary-nav">
      {SECONDARY.map(({ tab, label, Icon, testid }) => (
        <button key={tab} type="button" className="bi-pill" data-active={active === tab} onClick={() => onOpen(tab)} data-testid={testid}>
          <Icon className="h-4 w-4" />{label}
        </button>))}
    </div>
  );
}

export default function BookingHomeCards({ onOpen }) {
  return (
    <div className="bi-home space-y-6" data-testid="bi-home">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4">
        <div>
          <h1 className="bi-title text-4xl sm:text-5xl font-bold">Booking Intelligence</h1>
          <p className="mt-2 text-base md:text-lg text-[#5a3a22]">Create, manage and track all bookings &amp; orders across Purnabramha</p>
        </div>
        <SecondaryNav active="" onOpen={onOpen} />
      </div>
      <div className="bi-grid">{BI_CARDS.slice(0, 8).map((c, i) => <BiCard key={c.tab} c={c} i={i} onOpen={onOpen} />)}</div>
      <div className="bi-grid-last pb-4">{BI_CARDS.slice(8).map((c, i) => <BiCard key={c.tab} c={c} i={i + 8} onOpen={onOpen} />)}</div>
    </div>
  );
}
